import React from 'react';
import classes from './DependenciesPublishNote.module.scss';
import NoteIcon from '../../../../../assets/icons/note.svg';
import { WMCircularProgress } from '@walkme/wm-ui';
import { useTranslation } from 'react-i18next';

const keyPrefix = 'components.dialogs.publishNotificationConfirm.dependenciesPublishNote';

const DependenciesPublishNote = ({ unPublishedDependencies, loading }: $TSFixMe) => {
    const { t } = useTranslation('', { keyPrefix });

    const textMessage = (deployables: $TSFixMe) => {
        const deployablesLength = (deployables && deployables.reduce((acc: $TSFixMe, { checkedIds }: $TSFixMe) => acc + checkedIds.length, 0)) || 0;

        return t('YouHaveModifiedItems', { count: deployablesLength });
    };

    const publishItems = !loading && unPublishedDependencies?.length > 0;

    return loading ? (
        <div className={classes.loaderWrapper}>
            <WMCircularProgress />
            <span className={classes.loaderText}>{t('loadingDependencies')}</span>
        </div>
    ) : (
        <>
            {publishItems && (
                <div className={classes.root}>
                    <img src={NoteIcon} alt={t('note-alt')} />
                    <div>
                        <>
                            <b>{t('note')}</b> {textMessage(unPublishedDependencies)}
                        </>
                    </div>
                </div>
            )}
        </>
    );
};

export default DependenciesPublishNote;
